import '@fancyapps/fancybox';
import {animateInViewport} from "../transition";

$( '.image-carousel' ).each( function() {
	const $this = $( this );

	const swiperConfig = {
		loop: false,
		navigation: {
			nextEl: $this.parents( '.carousel-container' ).find( '.carousel-next' )[ 0 ],
			prevEl: $this.parents( '.carousel-container' ).find( '.carousel-previous' )[ 0 ],
		},
		slidesPerView: 1,
		spaceBetween: 8,
		grabCursor: true,
		speed: 600,
		on: {
			afterInit: function( swiper ) {
				setTimeout( () => {
					animateInViewport();
				}, 100 );
			},
		},
	};

	var swiper = new Swiper( this, swiperConfig );

	const slidersCount = swiper.slides.length;
	const $progressBar = $this.parents( '.carousel-container' ).find( '.progress-bar' );
	const $index = $this.parents( '.carousel-container' ).find( '.carousel-index' );

	$progressBar.css( { 'width': 100 / slidersCount + '%' } );

	swiper.on( 'slideChange slideChangeTransitionEnd', function() {
		$progressBar.css( { 'width': (100 / slidersCount) * (this.activeIndex + 1) + '%' } );
		$index.html( this.activeIndex + 1 );

		let fancyboxImage = $this.find( '.swiper-slide' ).eq( swiper.realIndex ).attr( 'data-fancybox-image' );
		$this.parents( '.carousel-container' ).find( '.carousel-zoom' ).attr( 'href', fancyboxImage );

		animateInViewport();
	} );
} );

$( '.properties-carousel' ).each( function() {
	const $this = $( this );

	const swiperConfig = {
		loop: false,
		autoHeight: false,
		navigation: {
			nextEl: $this.parents( '.carousel-container' ).find( '.carousel-next' )[ 0 ],
			prevEl: $this.parents( '.carousel-container' ).find( '.carousel-previous' )[ 0 ],
		},
		slidesPerView: 1,
		spaceBetween: 20,
		grabCursor: true,
		speed: 600,
		breakpoints: {
			1024: {
				slidesPerView: 2.15,
				spaceBetween: 124,
			},
		},
		on: {
			afterInit: function( swiper ) {
				setTimeout( () => {
					animateInViewport();
				}, 100 );
			},
		},
	};

	const swiper = new Swiper( this, swiperConfig );

	let slidersCount;
	if ( $( window ).width() < 768 ) {
		slidersCount = swiper.slides.length;
	} else {
		slidersCount = swiper.slides.length - 1;
	}

	const $progressBar = $this.parents( '.carousel-container' ).find( '.progress-bar' );

	$progressBar.css( { 'width': 100 / slidersCount + '%' } );

	swiper.on( 'slideChange slideChangeTransitionEnd', function() {
		$progressBar.css( { 'width': (100 / slidersCount) * (this.activeIndex + 1) + '%' } );

		animateInViewport();
	} );
} );
